import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { WebcontentService } from 'src/app/services/webcontent/webcontent.service';

@Component({
  selector: 'app-popover-agreement',
  templateUrl: './popover-agreement.component.html',
  styleUrls: ['./popover-agreement.component.scss'],
})

export class PopoverAgreementComponent implements OnInit {
  @ViewChild(IonContent,{ static: false }) content: IonContent;

  public data: any;
  public step: boolean = false;
  public title: string;
  public url: string;
  firstToOpen: string;
  termsPage:string;
  policyPage:string;
  agreed : boolean = false;
  privacyAgreed : boolean = false;
  pageNowOpen:string;
  noteElement;


  constructor(
    private readonly configService: ConfigService,
    private readonly navigator: Navigator,
    private readonly webContentService: WebcontentService,
    private eventsService:EventsService
  ){}

  

  ngOnInit(): void {
    this.noteElement = document.getElementById('note');
    this.data = this.navigator?.activePopovers[this.navigator.activePopovers.length-1]?.componentProps?.data;
    this.termsPage  = this.configService.getConfig().FEATURE_TERMS_SINGUP_PAGE_CODE ?? 'signup-terms'; 


    const externalLinks = this.configService
    .getExternalLinks()
    .payload.filter((link) => link.code == this.data.code);

    const url = externalLinks[0].url;
    this.updatePage(url);
  }

  private updatePage(url: string): any{
    this.url = url;
    this.title = this.configService?.getExternalLinks()?.payload?.filter(link => link?.code == this.termsPage)[0]?.title;
    this.webContentService.updateExternalLink(this.url);
    this.eventsService.publish("event:reload:externallinks");
  }

  public rejected = () => {
    this.navigator.activePopovers[this.navigator.activePopovers.length-1].dismiss();
    return this.data?.decline();
  }

  public accepted(): any{
      this.agreed = true;
      this.navigator.activePopovers[this.navigator.activePopovers.length-1].dismiss();
      return this.data?.accept();
  }
  closePopover = () => {
    if(!this.agreed){
      this.data?.closePopover();
    } 
    this.navigator.activePopovers[this.navigator.activePopovers.length-1].dismiss();
  }

}
